import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface FilterRow {
  field: string;
  operator: string;
  value: string;
}

@Component({
    selector: 'app-analysis-advanced-filter',
    templateUrl: './analysis-advanced-filter.component.html',
    styleUrls: ['./analysis-advanced-filter.component.scss'],
    standalone: false
})
export class AnalysisAdvancedFilterComponent implements OnInit {

  source!: string;

  datasetFields: string[] = [];

  commonFields: string[] = [
    'Product Name',
    'Generic Name',
    'Substance',
    'Adverse Event',
    'Reaction Term',
    'Event Term',
    'Age Group',
    'Patient Age Group',
    'Gender',
    'Country',
    'Region',
    'Report Type',
    'Report Category',
    'Seriousness',
    'Serious',
    'Case ID'
  ];

  operators = [
    { label: 'Equals', value: '=' },
    { label: 'Not Equals', value: '!=' },
    { label: 'Contains', value: 'contains' },
    { label: 'Starts With', value: 'startsWith' },
    { label: 'Ends With', value: 'endsWith' },
    { label: 'Greater Than', value: '>' },
    { label: 'Less Than', value: '<' }
  ];

  filters: FilterRow[] = [];

  constructor(
    private dialogRef: MatDialogRef<AnalysisAdvancedFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    this.source = this.data?.source;

    this.loadFields();

    this.addFilter();

  }

  loadFields(): void {

    this.datasetFields = this.commonFields;

  }

  addFilter(): void {

    this.filters.push({
      field: '',
      operator: '',
      value: ''
    });

  }

  removeFilter(index: number): void {

    this.filters.splice(index, 1);

  }

  applyFilters(): void {

    this.dialogRef.close(this.filters);

  }

  cancel(): void {

    this.dialogRef.close();

  }

}